export const common = {
  // Navigation
  aboutUs: 'About Us',
  services: 'Services',
  brands: 'Brands',
  marketInsights: 'Market Insights',
  contact: 'Contact',
  
  // Hero Section
  heroTitle: 'Bridging European Fashion with Chinese Markets',
  heroSubtitle: 'XINRUNMODA connects European brands with Chinese retail channels',
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  
  // About Section
  whoWeAre: 'Who We Are',
  aboutDescription1: 'Leveraging Hong Kong\'s role as an international trade hub, XINRUNMODA bridges European brands and Chinese retail channels. We curate premium European fashion and deliver reliable, end-to-end supply chain services.',
  aboutDescription2: 'Our strategic location in Hong Kong positions us perfectly to understand both European fashion excellence and Chinese market dynamics, enabling seamless cross-cultural business relationships.',
  partnerBrands: 'Partner Brands',
  retailPartners: 'Retail Partners',
  
  // Services Section
  ourServices: 'Our Services',
  servicesDescription: 'From brand sourcing to market penetration, we provide comprehensive fashion trade solutions',
  brandSourcing: 'Brand Sourcing',
  brandSourcingDesc: 'Curating premium European fashion brands for unique market offerings',
  supplyChain: 'Supply Chain Management',
  supplyChainDesc: 'End-to-end logistics solutions ensuring timely and efficient delivery',
  marketEntry: 'Market Entry',
  marketEntryDesc: 'Facilitating European brand entry into Chinese markets with localized support',
  retailNetwork: 'Retail Network',
  retailNetworkDesc: 'Extensive retail partner network across major Chinese cities',
  
  // Brands Section
  featuredBrands: 'Featured Brands',
  brandsDescription: 'We partner with Europe\'s finest fashion brands to bring the latest trends to Chinese consumers',
  
  // Market Insights Section
  marketInsightsTitle: 'Market Insights',
  marketInsightsDescription: 'Deep understanding of Chinese fashion market trends and consumer preferences',
  
  // Contact Section
  contactTitle: 'Contact Us',
  contactDescription: 'Ready to start your fashion trade journey? Let\'s discuss how we can help your brand succeed in the Chinese market.',
  getInTouch: 'Get in Touch',
  ourLocation: 'Our Location',
  emailUs: 'Email Us',
  
  // Footer
  footerDescription: 'XINRUNMODA - Professional fashion trade company connecting European brands with Chinese markets',
  quickLinks: 'Quick Links',
  contactInfo: 'Contact Information',
  followUs: 'Follow Us',
  allRightsReserved: 'All rights reserved'
};